import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import AkodeReportFilter from "../Filters/AkodeReportFilter";
import { ColumnHelper } from "util/TableHelper";

import { Table, Empty, Col, Row, Tooltip, message } from "antd";
import { BarsOutlined, FileExcelOutlined } from "@ant-design/icons";
import config from "../../util/ApiforContext";
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const Report = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    startDate: "",
    endDate: ""
  });
  const [tabQueryKey, setTabQueryKey] = useState(undefined);
  const [tabQuery, setTabQuery] = useState("");
  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const callback= (key)=> {
    onClearTableFilter();
    setTableData({
        data: [],
        total: 0,
        loading: true,
        });
    setTabQueryKey(key);
    const { skip, take } = tableDataQueryOptions;
    
    RequestHandler.get(
        key === "0" || key === undefined? 
        `/ToslaReport?IsDailyReport=true&$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`:
        `/ToslaReport?IsDailyReport=false&$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
        ).then((response) => {
        setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
        });
    });
  }

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;
    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }
    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = (key) => {
    setTableData({
      ...tableData,
      loading: true,
    });
    const { skip, take,startDate,endDate } = tableDataQueryOptions;
    startDate === "" ? 
     RequestHandler.get(
        tabQueryKey === "0" || tabQueryKey === undefined ? `/ToslaReport?IsDailyReport=true&$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
      : `/ToslaReport?IsDailyReport=false&$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      })
      :
      RequestHandler.get(
        tabQueryKey === "0" || tabQueryKey === undefined ? `/ToslaReport?IsDailyReport=true&StartDateFilter=${startDate}&EndDateFilter=${endDate}&$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
        : `/ToslaReport?IsDailyReport=false&StartDateFilter=${startDate}&EndDateFilter=${endDate}&$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
        ).then((response) => {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
        });

  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
      startDate:"",
      endDate:""
    });
  };

  const onFinishTableFilter = (query,model) => {
    setTableDataQueryOptions((prevState) => {
     if(model.startDate){
      return { skip: 0, current: 1, take: prevState.take,startDate: moment(model.startDate).format("DD-MM-YYYY"), endDate: moment(model.endDate).format("DD-MM-YYYY"), filter: query };

     }else{
      return { skip: 0, current: 1, take: prevState.take,startDate: "", endDate: "", filter: query };

     }
    });
  };

  const onClickExportExcel = () => {
     const hideMessage = message.loading("Excel indiriliyor...", 0);
     const { skip, take,startDate,endDate } = tableDataQueryOptions;
     startDate === "" ? 
            RequestHandler.post(
                `/ToslaReport/ExportExcel`,
                {
                query: getFilterQuery(),
                IsDailyReport : tabQueryKey === "0" || tabQueryKey === undefined ? true : false
                },
                false
            ).then((response) => {
                hideMessage();
                if (response) {
                  const base64String = response.base64;
        
                  // Base64 verisini binary'e çevir
                  const byteCharacters = atob(base64String);
                  const byteNumbers = new Array(byteCharacters.length);
                  for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }
                  const byteArray = new Uint8Array(byteNumbers);
            
                  // Blob oluştur
                  const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            
                  // URL oluştur
                  const url = URL.createObjectURL(blob);
            
                  // İndirme işlemini başlat
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = response.fileName; // İndirilmiş dosyanın ismi
                  document.body.appendChild(a);
                  a.click();
            
                  // Temizlik
                  URL.revokeObjectURL(url);
                  document.body.removeChild(a);
                }
            })
       :
            RequestHandler.post(
                `/ToslaReport/ExportExcel`,
                {
                query: getFilterQuery(),
                IsDailyReport : tabQueryKey === "0" || tabQueryKey === undefined ? true : false,
                StartDate:startDate,
                EndDate: endDate
                },
                false
            ).then((response) => {
                hideMessage();
                if (response) {
                window.open(
                    `${
                    config.apiUrl
                    }/ToslaReport/DownloadExcel?fileName=${response.fileName}&t=${encodeURIComponent(response.fileValue)}`
                );
                }
            });
  };

  const tableColumns = [
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      render: (data, row, index) =>  moment(data).format("DD.MM.YYYY"),
    },
    {
        title: "Gelen",
        dataIndex: "collectAmount",
        render: ColumnHelper.renderDecimal,
      },
      {
          title: "Giden",
          dataIndex: "paymentAmount",
          render: ColumnHelper.renderDecimal,
        }
  ];
  const tableColumnsMonthly = [
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      render: (data, row, index) =>  moment(data).format("MMMM YYYY"),
    },
    {
        title: "Gelen",
        dataIndex: "collectAmount",
        render: ColumnHelper.renderDecimal,
      },
      {
          title: "Giden",
          dataIndex: "paymentAmount",
          render: ColumnHelper.renderDecimal,
        }
  ];

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> RAPOR
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>
      <Tabs defaultActiveKey="0" onChange={callback}>
              <TabPane tab={<span>Gün Bazlı</span>} key="0">
              <Row id="tableArea">
              <Col span={24}>
                  <AkodeReportFilter
                        onClearFilter={onClearTableFilter}
                        onFinishFilter={onFinishTableFilter}
                        monthly = {false}
                        style={{ marginTop: 12, marginBottom: 12 }}
                    />
                  </Col>
                <Col span={24}>
                  <Table
                    columns={tableColumns.filter((column) => !column.isRowDetail)}
                    locale={{
                      emptyText: (
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description="Veri Yok"
                        />
                      ),
                    }}
                    style={{
                      overflowX: "auto",
                      maxHeight: "100%",
                      width: "100%",
                    }}
                    rowKey="id"
                    filterable={true}
                    sortable={true}
                    pageable={true}
                    onChange={paging}
                    pagination={{
                      defaultPageSize: tableDataQueryOptions.take,
                      pageSizeOptions: ["15", "25", "50", "100"],
                      total: tableData.total,
                      current: tableDataQueryOptions.current,
                    }}
                    dataSource={tableData.data}
                    loading={tableData.loading}
                    size="small"
                    summary={pageData => {
                      let totalCollectAmount = 0;
                      let totalPaymentAmount = 0;
              
                      pageData.forEach(({ collectAmount, paymentAmount }) => {
                        totalCollectAmount += collectAmount;
                        totalPaymentAmount += paymentAmount;
                      });
              
                      return (
                        <>
                          <Table.Summary.Row>
                            <Table.Summary.Cell ><span style={{textAlign:'center'}}>{<>Toplam</>}</span></Table.Summary.Cell>
                            <Table.Summary.Cell><span style={{textAlign:'center'}}>{<>{totalCollectAmount.toLocaleString("tr-TR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}</>}</span></Table.Summary.Cell>
                            <Table.Summary.Cell><span style={{textAlign:'center'}}>{<>{totalPaymentAmount.toLocaleString("tr-TR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}</>}</span></Table.Summary.Cell>
                          </Table.Summary.Row>
                        </>
                      );
                    }}
                  />
                </Col>
              </Row>
              </TabPane>
              <TabPane tab={<span>Ay Bazlı</span>} key="1">
              <Row id="tableArea">
                  <Col span={24}>
                  <AkodeReportFilter
                        onClearFilter={onClearTableFilter}
                        onFinishFilter={onFinishTableFilter}
                        monthly = {true}
                        style={{ marginTop: 12, marginBottom: 12 }}
                    />
                  </Col>
             
                <Col span={24}>
                  <Table
                    columns={tableColumnsMonthly.filter((column) => !column.isRowDetail)}
                    locale={{
                      emptyText: (
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description="Veri Yok"
                        />
                      ),
                    }}
                    style={{
                      overflowX: "auto",
                      maxHeight: "100%",
                      width: "100%",
                    }}
                    rowKey="id"
                    filterable={true}
                    sortable={true}
                    pageable={true}
                    onChange={paging}
                    pagination={{
                      defaultPageSize: tableDataQueryOptions.take,
                      pageSizeOptions: ["15", "25", "50", "100"],
                      total: tableData.total,
                      current: tableDataQueryOptions.current,
                    }}
                    dataSource={tableData.data}
                    loading={tableData.loading}
                    size="small"
                    summary={pageData => {
                        let totalCollectAmount = 0;
                        let totalPaymentAmount = 0;
                
                        pageData.forEach(({ collectAmount, paymentAmount }) => {
                          totalCollectAmount += collectAmount;
                          totalPaymentAmount += paymentAmount;
                        });
                
                        return (
                          <>
                            <Table.Summary.Row>
                              <Table.Summary.Cell ><span style={{textAlign:'center'}}>{<>Toplam</>}</span></Table.Summary.Cell>
                              <Table.Summary.Cell><span style={{textAlign:'center'}}>{<>{totalCollectAmount.toLocaleString("tr-TR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                          })}</>}</span></Table.Summary.Cell>
                              <Table.Summary.Cell><span style={{textAlign:'center'}}>{<>{totalPaymentAmount.toLocaleString("tr-TR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                          })}</>}</span></Table.Summary.Cell>
                            </Table.Summary.Row>
                          </>
                        );
                      }}
                  />
                </Col>
              </Row>
             </TabPane>
            </Tabs>
    
            
      
    </>
  );
};

export default Report;
